import { useEffect, useState } from "react";

type Dimension = {
  height: number;
  width: number;
};

export const useResizeObserver = (
  targetRef: React.RefObject<HTMLDivElement | null>[],
) => {
  const [dimensions, setDimensions] = useState<Dimension[]>([]);

  useEffect(() => {
    const elements = targetRef.map(ref => ref.current);
    const observer = (cb?: (props: DOMRectReadOnly) => void) =>
      new ResizeObserver(([entry]) => {
        const dimension = entry.contentRect;
        cb?.(dimension);
      });

    elements?.map(e => {
      if (!e) return;
      observer(props => {
        setDimensions(prev => [...prev, props]);
      }).observe(e);
    });

    return () => observer().disconnect();
  }, [...targetRef]);

  return [...dimensions] as const;
};
